export const AUTH_STORAGE_KEYS = {
  accessToken: "itaas.auth.accessToken",
  refreshToken: "itaas.auth.refreshToken",
  userId: "itaas.auth.userId",
  tenantId: "itaas.auth.tenantId",
  expiresAt: "itaas.auth.expiresAt",
  session: "itaas.auth.session",
} as const;

/** Throttle sonde refresh IAM dans verifySession (ms). */
export const AUTH_REFRESH_PROBE_KEY = "itaas.auth.lastRefreshProbe";
export const AUTH_REFRESH_PROBE_INTERVAL_MS = 30_000;

/** Bloque les relais SSO vers Suite pendant une déconnexion centralisée en cours. */
export const AUTH_LOGOUT_PENDING_KEY = "itaas.auth.logoutPending";
export const AUTH_LOGOUT_PENDING_MS = 15_000;

export const MOCK_DELAY_MS = 300;
export const TOKEN_TTL_MS = 60 * 60 * 1000;
export const REFRESH_THRESHOLD_MS = 5 * 60 * 1000;

export const DEMO_TENANT_ID = "tenant-demo";
export const DEMO_TENANT_SLUG = "demo";
